import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import logo from "../Assets/logo.png";
import { NavLink, useLocation } from "react-router";
import NavDropdown from 'react-bootstrap/NavDropdown';
import Image from 'react-bootstrap/Image';

function NavBar() {
    const [expand, updateExpanded] = useState(false);
    const [navColour, updateNavbar] = useState(false);
    const location = useLocation();
    const isParentActive = ["/solutionsenterprise", "/webapplication", "/offshoreteams"].includes(location.pathname);

    function scrollHandler() {
        if (window.scrollY >= 20) {
            updateNavbar(true);
        } else {
            updateNavbar(false);
        }
    }

    const handleToggle = () => updateExpanded(expand ? false : "expand");
    const handleClose = () => updateExpanded(false);

    window.addEventListener("scroll", scrollHandler);

    return (
        <Navbar
            expanded={expand}
            fixed="top"
            expand="md"
            className={`bg-white pb-0 ${navColour ? "sticky" : ""}`}
        >
            <Navbar.Brand href="/" className="navbar-brand ps-3 ps-md-0">
                <Image src={logo} className="logo py-1" alt="brand" />
            </Navbar.Brand>
            <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                onClick={handleToggle}
            >
                <span></span>
                <span></span>
                <span></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ms-auto align-items-center" defaultActiveKey="#home">
                    <Nav.Item>
                        <NavLink to="/" onClick={handleClose}>Home</NavLink>
                    </Nav.Item>

                    <Nav.Item>
                        <NavLink to="/about" onClick={handleClose}>About</NavLink>
                    </Nav.Item>

                    <Nav.Item>
                        <NavLink to="/service" onClick={handleClose}>Services</NavLink>
                    </Nav.Item>

                    <Nav.Item>
                        <NavLink to="/contact" onClick={handleClose}>Contact</NavLink>
                    </Nav.Item>
                </Nav>
            </Navbar.Collapse>
            <div className="mob-overlay"></div>
        </Navbar>
    );
}

export default NavBar;